import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "reactstrap";
import { joinCss, getZipFileLink } from "../helpers/utils";
import axios from "axios";

import appClasses from "../App.module.scss";
import classes from "./downloadAllSpecificationsButton.module.scss";

class downloadAllSpecificationsButton extends Component {
  state = {
    lastSpecifications: []
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.lastSpecifications.length > 0) {
      this.setState({ lastSpecifications: nextProps.lastSpecifications });
    }
  }

  downloadAllFiles = () => {
    axios
      .post(
        "/api/files/downloadAllSpecifications",
        this.state.lastSpecifications
      )
      .then(function(response) {
        var link = getZipFileLink(response.data);
        window.location = link;
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    return (
      <Row>
        <Col
          sm="6"
          md="4"
          lg="3"
          xl="2"
          className={joinCss(
            classes.headerButton,
            appClasses["right-align-div"],
            "offset-9"
          )}
        >
          <Button
            color="primary"
            onClick={this.downloadAllFiles}
            className={classes.downloadAllButton}
          >
            הורד את כל הפרקים
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    lastSpecifications: state.files.lastSpecifications
  };
};

export default connect(
  mapStateToProps,
  null
)(downloadAllSpecificationsButton);
